import ensureZepto from 'amkit3-modules/utils/ensure-zepto'
import ensureHuyaYa from 'amkit3-modules/utils/huya/ensure-ya'

const PRO = 'huya_web'

class HuyaYaApi {
  constructor () {
    this.caches = []

    ensureZepto((_, $) => {
      $(() => {
        ensureHuyaYa((_, YA) => {
          if (!global.ya) {
            const source = {
              pro: $('body').data('ya-pro') || PRO,
              pas: YA.cookie.get('username') || '',
              yyuid: YA.cookie.get('yyuid') || '',
              pageType: 'root',
              rso: '',
              rso_desc: ''
            }

            global.ya = new YA(source.pro, source.pas, {
              pageType: source.pageType,
              yyuid: source.yyuid
            })
          }

          while (this.caches.length) {
            let data = this.caches.shift()
            this.yaReport(data)
          }
        })
      })
    })
  }
  yaReport (data) {
    if (!data) return
    if (!data.eid) return

    if (!global.ya) {
      this.caches.push(data)
    } else {
      global.ya.reportProductEvent(data)
    }
  }
}

let sharedInstance = null

const getSharedInstance = () => {
  if (!sharedInstance) {
    sharedInstance = new HuyaYaApi()
  }
  return sharedInstance
}

const yaReport = data => {
  getSharedInstance().yaReport(data)
}

export default ({
  yaReport
})
